<template lang="html">
  <div v-if="!isLoading" class="container">
    <div class="row justify-center">

      <!-- Photos -->
      <div class="col-xl-3 col-lg-6">
        <StatsCard icon="fa fa-file-image" title="Photos/Files" :total="picturesTotal" :last-month="picturesLastMonth" />
      </div>

      <!-- Observations -->
      <div class="col-xl-3 col-lg-6">
        <StatsCard icon="fas fa-binoculars" title="Observations" :total="observationsTotal" :last-month="observationsLastMonth"
          :to="{ name: 'ProfileObservations', params: { id: $route.params.id } }" />
      </div>

      <!-- Forum Posts -->
      <div class="col-xl-3 col-lg-6">
        <StatsCard icon="fas fa-comments" title="Forum Posts" :total="postsTotal" :last-month="postsLastMonth" />
      </div>

      <!-- Locations -->
      <div class="col-xl-3 col-lg-6">
        <StatsCard icon="fas fa-map-marker-alt" title="Locations" :total="locationsTotal" :last-month="locationsLastMonth" />
      </div>

    </div>
    <div class="row justify-center mt-2">

      <!-- Measurements -->
      <div class="col-xl-4 col-lg-6">
        <StatsCard icon="fas fa-ruler-vertical" title="Measurements" :total="observationsRecordsTotal" :last-month="observationsRecordsLastMonth" />
      </div>

      <!-- Project Likes -->
      <div class="col-xl-3 col-lg-6">
        <StatsCard icon="fa fa-thumbs-up" title="Project Likes" :total="likesTotal" :last-month="likesLastMonth" />
      </div>

      <!-- Memberships -->
      <div class="col-xl-4 col-lg-6">
        <StatsCard title="Project Memberships" :total="projectsTotal" :last-month="projectsLastMonth"
          :to="{ name: 'ProfileProjects', params: { id: $route.params.id } }">
          <template #icon>
            <CitSciProjectIcon size="2x" />
          </template>
        </StatsCard>
      </div>

    </div>
  </div>

  <!-- Loading Placeholders -->
  <div v-else class="container">
    <div class="row justify-center">
      <div v-for="n in 4" :key="'mock-r1-'+n" class="col-xl-3 col-lg-6">
        <PlaceholderStatsCard />
      </div>
    </div>
    <div class="row justify-center mt-2">
      <div v-for="(colClass, idx) in ['col-xl-4 col-lg-6','col-xl-3 col-lg-6','col-xl-4 col-lg-6']" :key="'mock-r2-'+idx" :class="colClass">
        <PlaceholderStatsCard />
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState,} from 'vuex'
import CitSciProjectIcon from "../../../common/CitSciProjectIcon.vue";
import PlaceholderStatsCard from "./PlaceholderStatsCard.vue";
import StatsCard from "./StatsCard.vue";

export default {
  components: {
    CitSciProjectIcon,
    PlaceholderStatsCard,
    StatsCard,
  },
  created() {
    this.getUserStats()
  },
  computed: {
    ...mapGetters({
      userVuex: "user/profile/id",
    }),
    ...mapState({
      isLoading: state => state.user.profile.stats.isLoading,

      likesTotal: state => state.user.profile.stats.likesTotal,
      likesLastMonth: state => state.user.profile.stats.likesLastMonth,

      locationsTotal: state => state.user.profile.stats.locationsTotal,
      locationsLastMonth: state => state.user.profile.stats.locationsLastMonth,

      observationsRecordsTotal: state => state.user.profile.stats.observationsRecordsTotal,
      observationsRecordsLastMonth: state => state.user.profile.stats.observationsRecordsLastMonth,

      observationsTotal: state => state.user.profile.stats.observationsTotal,
      observationsLastMonth: state => state.user.profile.stats.observationsLastMonth,

      picturesTotal: state => state.user.profile.stats.picturesTotal,
      picturesLastMonth: state => state.user.profile.stats.picturesLastMonth,

      postsTotal: state => state.user.profile.stats.postsTotal,
      postsLastMonth: state => state.user.profile.stats.postsLastMonth,

      projectsTotal: state => state.user.profile.stats.projectsTotal,
      projectsLastMonth: state => state.user.profile.stats.projectsLastMonth,
    }),
  },
  methods: {
    ...mapActions({
      getUserStats: 'user/profile/stats/get',
    })
  }
}
</script>

<style scoped lang="scss">
</style>
